document.addEventListener("cart:item-added", function (evt) {
    addUpsellsToCart()
});

const currencyCode = document.getElementById('currencyCode').value
const currencySymbol = document.getElementById('currencySymbol').value
const rtlLocales = ['EUR', 'DKK']

document.addEventListener("DOMContentLoaded", function() {
  document.getElementById('prop65Modal').onclick = openProp65Modal
});

function openProp65Modal() {
  document.getElementById('prop65ModalWindow').style.display = 'block';
  disableScroll();
}

function closeProp65Modal() {
  document.getElementById('prop65ModalWindow').style.display = 'none';
  enableScroll();
}

function formatPrice(price) {
  var rightToLeft = false
  rtlLocales.forEach(code => {
    if (code == currencyCode){
      rightToLeft = true 
    }
  })
  if (rightToLeft) {
    return price + ' ' + currencySymbol
  } else {
    return currencySymbol + price
  }
}

function formatPriceWithCode(price) {
  var rightToLeft = false
  rtlLocales.forEach(code => {
    if (code == currencyCode){
      rightToLeft = true 
    }
  })
  let priceToReturn = ''
  if (rightToLeft) {
    priceToReturn = price + ' ' + currencySymbol
  } else {
    priceToReturn = currencySymbol + price
  }
  priceToReturn += ' ' + currencyCode
  return priceToReturn
}

function updateActiveColor(elemId) {
  const selectors = document.querySelectorAll('.option-color-selector');
  for (let i = 0; i < selectors.length; i++) {
    selectors[i].classList.remove('active');
  }
  document.getElementById(elemId).classList.add('active');
}

function addUpsellsToCart(){
  const allUpsells = document.querySelectorAll('.upsell-container');
  let upsellsToAdd = [];
  for (let i = 0; i < allUpsells.length; i++) {
    const u = allUpsells[i];
    if (u.classList.contains('active')) {
      upsellsToAdd.push(u.querySelector('.upsell-atc-id').value); 
    }
  }
  if (upsellsToAdd.length > 0) {
      let formData = {
       'items': []
      };
     upsellsToAdd.forEach(u => formData.items.push({ id: u, quantity: 1 }));
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

//Format gallon calculation
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function closeUpsellModal() {
  document.getElementById('upsellModal').style.display = 'none';
  enableScroll()
}

function openUpsellModal(id) {
  const upsellImageURL = document.getElementById(id + '-upsell-image').value;
  const upsellDescription = document.getElementById(id + '-upsell-description').innerHTML;

  document.getElementById('upsell-modal-image').src = upsellImageURL;
  document.getElementById('upsell-modal-info').innerHTML = upsellDescription;

  document.getElementById('upsellModal').style.display = 'block';
  disableScroll()
}

function elementIsActive(elem) {
  let isActive = false;
  for (let i = 0; i < elem.classList.length; i++) {
    if (elem.classList[i] == 'active') {
      isActive = true;
    }
  }
  return isActive;
}

let priceRenderInterval = null

function renderPrices() {
  const mainPrice = document.querySelector('.product-price-container').querySelector('.main-price');
  let mainComparePrice = document.querySelector('.product-price-container').querySelector('.compare-price');

  const atcPrice = document.getElementById('atc_button_price');
  const atcComparePrice = document.getElementById('atc_button_compare_price');

  const selectedVariantCost = document.getElementById('selectedVariantCost').value;
  const selectedVariantComparePrice = document.getElementById('selectedVariantComparePrice').value;
  const totalUpsellCost = document.getElementById('totalUpsellCost').value

  const mainPriceToRender = getRenderedPrice(parseInt(selectedVariantCost) + parseInt(totalUpsellCost));
  const comparePriceToRender = getRenderedPrice(parseInt(selectedVariantComparePrice) + parseInt(totalUpsellCost));


  clearInterval(priceRenderInterval)
  mainPrice.innerHTML = formatPriceWithCode(mainPriceToRender);
  priceRenderInterval = setInterval(function(){
    updateMainPrice(mainPriceToRender);
  }, 250);
  
  atcPrice.innerHTML = formatPriceWithCode(mainPriceToRender);

  if (selectedVariantComparePrice) {
    updateMainComparePrice(comparePriceToRender)
    atcComparePrice.innerHTML = formatPriceWithCode(comparePriceToRender);
  }
}

function updateMainComparePrice(comparePriceToRender) {
  window.setTimeout(function () {
    let mainComparePrice = document.querySelector('.product-price-container').querySelector('.compare-price');
    if (mainComparePrice == null || mainComparePrice == undefined || mainComparePrice == "null" || !mainComparePrice) {
      updateMainComparePrice(comparePriceToRender);
    } else {
      mainComparePrice.innerHTML = formatPriceWithCode(comparePriceToRender);
    }
  }, 50);
}

function updateMainPrice(mainPriceToRender) {
  document.querySelector('.product-price-container').querySelector('.main-price').innerHTML = formatPriceWithCode(mainPriceToRender);
}

function toggleUpsell(id) {
  const box = document.getElementById(id + '-upsell-toggle-box');
  const check = document.getElementById(id + '-upsell-toggle-check');
  const upsellCost = document.getElementById(id + '-upsell-cost').value;
  const upsellContainer = document.getElementById(id + '-upsell-container');
  const totalUpsellCost = document.getElementById('totalUpsellCost');
  if (elementIsActive(upsellContainer)) {
    //Deselecting
    box.style.display = 'flex';
    check.style.display = 'none';
    upsellContainer.classList.remove('active');
    totalUpsellCost.value = parseInt(totalUpsellCost.value) - parseInt(upsellCost);
  } else {
    //Selecting
    box.style.display = 'none';
    check.style.display = 'flex';
    upsellContainer.classList.add('active')
    totalUpsellCost.value = parseInt(totalUpsellCost.value) + parseInt(upsellCost);
  }
  renderPrices();
}

function disableScroll() {
  document.body.style.overflowY = 'hidden';
}

function enableScroll() {
  document.body.style.overflowY = 'scroll';
}

function openSizeModal() {
  document.getElementById('sizeModal').style.display = 'block';
  disableScroll();
}

function closeSizeModal() {
  document.getElementById('sizeModal').style.display = 'none';
  enableScroll();
}

window.onclick = function (event) {
  if (event.target == document.getElementById('upsellModal')) {
    document.getElementById('upsellModal').style.display = "none";
    enableScroll();
  }

  if (event.target == document.getElementById('sizeModal')) {
    document.getElementById('sizeModal').style.display = "none";
    enableScroll();
  }
}

var numbersToFormat = document.getElementsByClassName('number-to-format');
for (let i = 0; i < numbersToFormat.length; i++) {
  numbersToFormat[i].innerHTML = numberWithCommas(numbersToFormat[i].innerHTML);
}

//Updaint Variant Details
document.addEventListener("product:variant-change", function (evt) {

  if (document.getElementById("filtrationSystem").value == "false") return
  const variant = evt.detail.variant;

  //Enable/Disable ATC button based on availability
  if (variant.available) {
      document.getElementById("AddToCart").disabled = false;
      document.getElementById("atc_button_text").innerHTML = 'ADD TO CART';
  } else {
      document.getElementById("AddToCart").disabled = true;
      document.getElementById("atc_button_text").innerHTML = 'SOLD OUT';
  }

  //Update Price
  document.getElementById('selectedVariantCost').value = variant.price;
  document.getElementById('selectedVariantComparePrice').value = variant.compare_at_price;
  renderPrices();

  //Change Price/Compare Price In Active Variant
  document.querySelector('[data-variant-filter-count="' + variant.option2 + '"]').querySelector('.filter-option-text--price').innerHTML = formatPrice(getRenderedPrice(variant.price));
  if (variant.compare_at_price != null) {
    comparePriceToRender = formatPrice(getRenderedPrice(variant.compare_at_price))
  } else {
    comparePriceToRender = '';
  }
  document.querySelector('[data-variant-filter-count="' + variant.option2 + '"]').querySelector('.filter-option-text--compare-price').innerHTML = comparePriceToRender;

  //Change Price/Compare Price In Inactive Variants
  const variantContainers = document.getElementsByClassName("filter-option-container");
  for (let i = 0; i < variantContainers.length; i++) {
    if (variantContainers[i].dataset.variantFilterCount != variant.option2) {
      variantContainers[i].querySelector('.filter-option-text--price').innerHTML = formatPrice(getRenderedPrice(document.getElementById(variant.option1 + ' / ' + variantContainers[i].dataset.variantFilterCount).value));
      let comparePriceToRender = document.getElementById(variant.option1 + ' / ' + variantContainers[i].dataset.variantFilterCount + '--compare').value;
      if (comparePriceToRender) {
        comparePriceToRender = formatPrice(getRenderedPrice(comparePriceToRender))
      } else {
        comparePriceToRender = '';
      }
      document.querySelector('[data-variant-filter-count="' + variantContainers[i].dataset.variantFilterCount + '"]').querySelector('.filter-option-text--compare-price').innerHTML = comparePriceToRender;
    }
  }

  // *START UPDATE BUTTON ACTIVE STATE* //

  //First make everything inactive
  const containers = document.getElementsByClassName("filter-option-container");
  for (let i = 0; i < containers.length; i++) {
    containers[i].classList.remove('active');
    containers[i].firstElementChild.classList.remove('active');
    //Also update relevant dataset
    containers[i].dataset.variantColor = variant.option1;
    containers[i].dataset.variantFilterCount = (i + 1) * 2 + ' Filters';
  }
  const promotions = document.getElementsByClassName("filter-promotion");
  for (let i = 0; i < promotions.length; i++) {
    promotions[i].classList.remove('active');
    promotions[i].querySelector('.filter-promotion-text').classList.remove('active');
    promotions[i].querySelector('.inactive-promotion-icon').style.display = 'block';
    promotions[i].querySelector('.active-promotion-icon').style.display = 'none';
  }

  //Now activate the relevant things
  document.querySelector('[data-variant-filter-count="' + variant.option2 + '"]').classList.add('active');
  document.querySelector('[data-variant-filter-count="' + variant.option2 + '"]').firstElementChild.classList.add('active');
  const promotion = document.querySelector('[data-variant-promotion-filter-count="' + variant.option2 + '"]')
  promotion.classList.add('active')
  promotion.querySelector('.filter-promotion-text').classList.add('active');
  promotion.querySelector('.inactive-promotion-icon').style.display = 'none';
  promotion.querySelector('.active-promotion-icon').style.display = 'block';

  //* HIDE STUFF FOR OOS *//
  const availableForm = document.getElementById(variant.title + "--oos-form");
  const upsells = document.getElementsByClassName('upsell-container');
  if (availableForm.innerHTML != "") {
     if (!variant.available) {
          const oos_forms = document.getElementsByClassName("oos-form");
          for (let i = 0; i < oos_forms.length; i++) {
            oos_forms[i].style.display = 'none';
          }
          availableForm.style.display = 'block';
          document.getElementById('system-fieldset').style.display = 'none';
          for (let i = 0; i < upsells.length; i++) {
            upsells[i].style.display = 'none'
          }
          document.getElementsByClassName('product-add-to-cart-container')[0].style.display = 'none'; 
      } else {
        const oos_forms = document.getElementsByClassName("oos-form");
        for (let i = 0; i < oos_forms.length; i++) {
          oos_forms[i].style.display = 'none';
        }
        document.getElementById('system-fieldset').style.display = 'block';
        for (let i = 0; i < upsells.length; i++) {
          upsells[i].style.display = 'flex'
        }
        document.getElementsByClassName('product-add-to-cart-container')[0].style.display = 'block';
      } 
  } else {
    const oos_forms = document.getElementsByClassName("oos-form");
    for (let i = 0; i < oos_forms.length; i++) {
      oos_forms[i].style.display = 'none';
    }
    document.getElementById('system-fieldset').style.display = 'block';
    for (let i = 0; i < upsells.length; i++) {
      upsells[i].style.display = 'flex'
    }
    document.getElementsByClassName('product-add-to-cart-container')[0].style.display = 'block';
  }

  //Ensure correct text in promotion text, and show or hide promotion based on if there actually is a promotion
  //Check if any visible variants should display a promotion, and update their stuff if so
  for (let i = 0; i < containers.length; i++) {
    let containerOption1 = containers[i].dataset.variantColor;
    let containerOption2 = containers[i].dataset.variantFilterCount;
    let promotionText = document.getElementById(containerOption1 + ' / ' + containerOption2 + '--promotion-text').value;
    if (!promotionText || promotionText == "" || promotionText == null) {
      //Hide Promotion
      document.querySelector('[data-variant-filter-count="' + containerOption2 + '"]').classList.remove('promotion');
      document.querySelector('[data-variant-filter-count="' + containerOption2 + '"]').firstElementChild.classList.remove('promotion');
      containers[i].querySelector('[data-variant-promotion-filter-count="' + containerOption2 + '"]').style.display = 'none';
    } else {
      containers[i].querySelector('.filter-promotion-text').firstElementChild.innerHTML = promotionText;
      //Show Promotion
      document.querySelector('[data-variant-filter-count="' + containerOption2 + '"]').classList.add('promotion');
      document.querySelector('[data-variant-filter-count="' + containerOption2 + '"]').firstElementChild.classList.add('promotion');
      containers[i].querySelector('[data-variant-promotion-filter-count="' + containerOption2 + '"]').style.display = 'flex';
    }
  }

  // *END UPDATE BUTTON ACTIVE STATE* //

  // *HANDLE VARIANT LEVEL UPSELLS* //
  const variantUpsells = document.getElementsByClassName('variant-upsell-container');
  let selectedUpsells = []
  for (let i = 0; i < variantUpsells.length; i++) {
    let upsell = variantUpsells[i]
    let isSelected = upsell.classList.contains('active') ? true : false
    let upsellVariant = upsell.id.split('-')[0]
    let upsellID = upsell.id.split('-')[1]
    let upsellProductID = document.getElementById(upsellVariant + '-' + upsellID + '-productID').value
    if (isSelected) {
      selectedUpsells.push(upsellProductID)  
    }

    if (upsellVariant == variant.id) {
      upsell.style.display = 'flex'
    } else {
      upsell.style.display = 'none' 
    }

    if (isSelected) {
      toggleUpsell(upsellVariant + '-' + upsell.id.split('-')[1])
    }
  }
  for (let i = 0; i < variantUpsells.length; i++) {
    let upsell = variantUpsells[i]
    let upsellVariant = upsell.id.split('-')[0]
    let upsellID = upsell.id.split('-')[1]
    let upsellProductID = document.getElementById(upsellVariant + '-' + upsellID + '-productID').value
    if (selectedUpsells.includes(upsellProductID) && upsellVariant == variant.id) {
      toggleUpsell(upsellVariant + '-' + upsellID)
    }
  }
});
